<div class="cm-table-cell" [class.cm-centered]="$centered()" [class.cm-header]="$header()">
    @let item = $item();
    @if (item?.error) {
        <div @fadeInPlaceholder class="cm-pill cm-error"></div>
    } @else if (!!item && item.data === null) {
        <div @fadeInPlaceholder class="cm-pill"></div>
    } @else {
        <ng-content></ng-content>
    }
</div>
